export default __webpack_public_path__ + "static/media/Meat.a16c28a8.png";